import { Form, Button, Popup } from "semantic-ui-react";
import {useFormik} from "formik";
import * as Yup from "yup";
import {toast} from "react-toastify";
import {useMutation} from "@apollo/client/react";
import {REGISTER} from "../../../gql/user"; 
import "./RegisterForm.scss";   

export default function RegisterForm(props) {
  const {setShowLogin} = props; 
  const [register] = useMutation(REGISTER);
  const formik = useFormik({
    initialValues: initialValues(),
      validationSchema: Yup.object({
        name: 
          Yup.string()
          .required("El nombre es obligatorio"),
        username: 
          Yup.string()
          .matches(/^[a-zA-Z0-9_]+$/, "El nombre de usuario solo puede contener letras, números y guiones bajos")
          .required("El usuario es obligatorio"),
        email: 
        Yup.string()
        .email("El correo no es válido").required("El correo es obligatorio"),
        password: Yup.string()
          .oneOf([Yup.ref("repeatPassword"), null], "Las contraseñas deben coincidir")
          .min(6, "La contraseña debe tener al menos 6 caracteres")
          .required("La contraseña es obligatoria"),
        repeatPassword: Yup.string()
          .oneOf([Yup.ref("password"), null], "Las contraseñas deben coincidir")
          .min(6, "La contraseña debe tener al menos 6 caracteres")
          .required("Repetir contraseña es obligatorio"),
      }),
      onSubmit: async(formData) => {
        try {
         const newUser = formData;
          delete newUser.repeatPassword;
          const result = await register({
            variables: {
              input: newUser,
            },
          });
          toast.success("Usuario registrado correctamente");
          setShowLogin(true);
        } catch (error) {
          toast.error(error.message);
          console.log(error.message);
        }
      }
    });


  return (
    <>
      <h2 className="register-form-title">Registrate para ver fotos y videos de tus amigos</h2>
      <Form className="register-form" onSubmit={formik.handleSubmit}>
        <Popup
          content={formik.errors.name}
          open={formik.touched.name && Boolean(formik.errors.name)}
          position="right center"
          trigger={
            <Form.Input
              type="text"
              placeholder="Nombre y Apellidos"
              name="name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              error={formik.touched.name && Boolean(formik.errors.name)}
            />
          }
        />

        <Popup
          content={formik.errors.username}
          open={formik.touched.username && Boolean(formik.errors.username)}
          position="right center"
          trigger={
            <Form.Input
              type="text"
              placeholder="Nombre de Usuario"
              name="username"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.username}
              error={formik.touched.username && Boolean(formik.errors.username)}
            />
          }
        />

        <Popup
          content={formik.errors.email}
          open={formik.touched.email && Boolean(formik.errors.email)}
          position="right center"
          trigger={
            <Form.Input
              type="text"
              placeholder="Correo Electronico"
              name="email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              error={formik.touched.email && Boolean(formik.errors.email)}
            />
          }
        />

        <Popup
          content={formik.errors.password}
          open={formik.touched.password && Boolean(formik.errors.password)}
          position="right center"
          trigger={
            <Form.Input
              type="password"
              placeholder="Contraseña"
              name="password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
              error={formik.touched.password && Boolean(formik.errors.password)}
            />
          }
        />

        <Popup
          content={formik.errors.repeatPassword}
          open={formik.touched.repeatPassword && Boolean(formik.errors.repeatPassword)}
          position="right center"
          trigger={
            <Form.Input
              type="password"
              placeholder="Repetir Contraseña"
              name="repeatPassword"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.repeatPassword}
              error={formik.touched.repeatPassword && Boolean(formik.errors.repeatPassword)}
            />
          }
        />

        <Button type="submit" className="btn-submit">
          Registrarse
        </Button>
      </Form>
    </>
  );
}

function initialValues() {
  return {
    name: "",
    username: "",
    email: "",    
    password: "",
    repeatPassword: ""
  };
}